<template>
  <div class="home">
    <!-- <h1 class="subtitle-1 grey--text">Obras</h1> -->

    <div v-if="loading" class="text-center mt-5">
      <img src="img/logo_cargando.gif" alt="apa" />
      <h1 class="title">Cargando . . .</h1>
    </div>
    <v-container class="my-5 " v-if="!loading">
      <v-card class="pa-3" flat>
        <v-card-text>
          <v-text-field type="text" label="Buscar obra" :value="busqueda" v-on:keyup="buscar" autofocus />
          <v-layout row v-for="obra in filtrado" :key="obra.codWorkSq">
            <v-flex class="sm6 xs12 md6" my-2>
              <div class="caption grey--text text-left">Obra</div>
              <div class="text-left font-weight-bold">{{ obra.title }}</div>
              <div
                v-if="['2107527', '2397120', '785849', '3519927', '1034657', '2835606'].includes($store.getters.user.username)">
                <v-icon v-if="obra.cantidadPistasBmatNacional == 0 && obra.cantidadPistasBmatNacional == 0"
                  class="grey--text" small>volume_off</v-icon>
                <span v-for="n in obra.cantidadPistasBmatNacional" :key="n">
                  <v-icon class="blue--text" small>volume_up</v-icon>
                </span>
                <span v-for="n in obra.cantidadPistasBmatInternacional" :key="n">
                  <v-icon class="green-text" small>volume_up</v-icon>
                </span>
                <ObraDetalle :obra="obra"
                  v-if="obra.cantidadPistasBmatNacional > 0 || obra.cantidadPistasBmatNacional > 0" />
              </div>
            </v-flex>
            <v-flex class="sm6 xs12" my-2>
              <div class="caption grey--text text-left">Participación</div>
              <div class="caption text-left" v-for="par in obra.participaciones" :key="par.autor.ipName">
                {{ par.autor.ipComplete }}
                {{ par.porcentPer }}%
              </div>
            </v-flex>
            <v-flex class="xs12 sm12 md12 lg12 xl12">
              <v-divider></v-divider>
            </v-flex>
          </v-layout>

        </v-card-text>
        <v-card-actions></v-card-actions>
        <div class="caption"> <v-icon class="grey--text" small>volume_off</v-icon> - Sin pistas de audio BMAT </div>
        <div class="caption"> <v-icon class="blue--text" small>volume_up</v-icon> - Pistas de audio BMAT Nacional </div>
        <div class="caption"> <v-icon class="green--text" small>volume_up</v-icon> - Pistas de audio BMAT Internacional
        </div>

      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import ObraDetalle from "@/components/obras/ObraDetalle.vue"

export default {

  components: { ObraDetalle },

  data() {
    return {
      obras: [],
      filtrado: [],
      busqueda: "",
      buscarTimer: null,
      loading: false,
      showDialog: true
    };
  },
  mounted() {
    this.loading = true;
    axios
      .get("/miapa/misobras")
      .then(response => {
        this.loading = false;



        this.obras = response.data.sort((a, b) => {
          {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
          }
        });
        this.filtrado = [...this.obras];
        console.log(this.obras);
      })
      .catch(error => {
        this.loading = false;
        console.log(error);
      });
  },
  methods: {
    buscar(e) {
      if (this.busqueda === e.target.value.toUpperCase()) {
        return;
      }
      this.busqueda = e.target.value.toUpperCase();

      if (this.buscarTimer) {
        clearTimeout(this.buscarTimer);
      }

      this.buscarTimer = setTimeout(() => {
        if (this.busqueda && this.busqueda.length > 2) {
          this.filtrado = [];

          // this.obras.forEach(obra => {
          //   obra.participaciones.forEach(par => {
          //     if (par.autor.ipComplete.toUpperCase().includes(this.busqueda)) {
          //       this.filtrado.push(obra);
          //     }
          //   })
          // });

          this.filtrado = this.obras.filter(obra => {
            return (
              obra.title.toUpperCase().includes(this.busqueda) ||
              obra.participaciones.some(par => {
                return par.autor.ipComplete
                  .toUpperCase()
                  .includes(this.busqueda);
              })
            );
          });
        } else {
          this.filtrado = this.obras;
        }

        this.buscarTimer = null;
      }, 500);
    },
  }
};
</script>

<style scoped>
.project.registrado {
  border-left: 4px solid #2196f3;
}

.project.procesando {
  border-left: 4px solid #455a64;
}

.project.retrasado {
  border-left: 4px solid #b71c1c;
}

.v-chip.registrado {
  background: #2196f3;
}

.v-chip.procesando {
  background: #455a64;
}

.v-chip.retrasado {
  background: #b71c1c;
}
</style>
